import { useEffect } from 'react';
import { useAuthContext } from '@/contexts/AuthContext';
import { useTeam } from '@/contexts/TeamContext';
import { setErrorContext } from '@/hooks/useErrorLogging';

/**
 * A headless component that lives inside the Auth and Team providers.
 * It observes the current user and team, and passes them to the 
 * global error logger which lives outside of the React context tree.
 */
export function ErrorContextManager(): null {
  const { user } = useAuthContext();
  const { currentTeamId } = useTeam();

  useEffect(() => {
    setErrorContext(user?.id || null, currentTeamId || null);
  }, [user?.id, currentTeamId]);

  // Clean up on unmount just in case
  useEffect(() => {
    return () => setErrorContext(null, null);
  }, []);

  return null;
}
